import * as RTooltip from '@radix-ui/react-tooltip'

/**
 * TooltipProvider — mount once near the app root. Shares timing across tooltips
 * (one opens after a short delay; neighbours then open instantly).
 */
export function TooltipProvider({ children }) {
  return (
    <RTooltip.Provider delayDuration={300} skipDelayDuration={150}>
      {children}
    </RTooltip.Provider>
  )
}

/**
 * Tooltip — wraps a single focusable child and shows `content` on hover/focus.
 * Replaces native `title=` (instant, styled, accessible). No content → renders
 * the child untouched.
 */
export function Tooltip({ content, children, side = 'top' }) {
  if (!content) {
    return children
  }
  return (
    <RTooltip.Root>
      <RTooltip.Trigger asChild>{children}</RTooltip.Trigger>
      <RTooltip.Portal>
        <RTooltip.Content className="tooltip" side={side} sideOffset={6}>
          {content}
          <RTooltip.Arrow className="tooltip-arrow" />
        </RTooltip.Content>
      </RTooltip.Portal>
    </RTooltip.Root>
  )
}
